import React from 'react';
import '../Login/LoginDialog.scss';
const LikeRoleDialog  = ({...props}) => {
	const handleClose = () => {
		props.onClose?.();
	};

	return (
		<div className="comm_popup" style={{ display: 'block' }}>
			<div className="comm_popup_wrap pa30">
				<div className="comm_popup_title">
					<h3>좋아요</h3>
				</div>
				<div className="comm_popup_content mt10">
					<p className="explain">가입한 주민만 좋아요를 할 수 있습니다.</p>
				</div>
				<div className="comm_popup_btn mt25">
					<button type="button" className="btn_check one" onClick={handleClose}>
						확인
					</button>
				</div>
			</div>
		</div>
	);
};

export default LikeRoleDialog ;
